import Vue from 'vue'
import MintUI from 'mint-ui'
import {Indicator} from 'mint-ui';
import {Toast} from 'mint-ui';
import {MessageBox} from 'mint-ui';
import $ from 'jquery';
import {Cookies} from '../../common/js/jquery-cookie.js';
import {verification} from './verification'

Vue.use(MintUI);

let common = {
  /**
   * 跳转到登录页面
   */
  jumpSign() {
    window.location.href = "/user/sign.html";
  },
  /**
   * 浮点数相减
   */
  subtractionNumber(num1, num2) {
    let sum = (Math.round(num1 * 100) - Math.round(num2 * 100)) / 100;
    sum = this.toFixedNum(sum, 2);
    return String(sum);
  },
  /**
   * 浮点数相加
   */
  addNumber(num1, num2) {
    let sum = (Math.round(num1 * 100) + Math.round(num2 * 100)) / 100;
    sum = this.toFixedNum(sum, 2);
    return String(sum);
  },
  /**
   * 保留两位小数
   */
  toFixedNum(money, num) {
    money = Number(money).toFixed(num);
    return String(money);
  },

  /**
   * 接口错误映射表
   */
  ErrorMap(key, errpyMsg) {
    let errorTips = {
      CustomerLogicException: 'show',
      InvalidArgumentException: '参数错误！',
      TokenLogicException: 'tokenOver', // 返回登录页
      TaskStatusError: '很抱歉，系统繁忙，请稍后重试！',
      RuntimeException: '很抱歉，系统繁忙，请稍后重试！',
      LogicException: '很抱歉，系统繁忙，请稍后重试！'
    }
    let errorTip = errorTips[key];
    Indicator.close();
    if (errorTip == 'show') {
      this.toastMsg(errpyMsg);
    } else {
      if (errorTip == 'tokenOver') {
        window.location.href = "/user/sign.html";
      } else {
        this.toastMsg(errorTip);
      }
    }
  },

  /**
   * 判断是否为微信浏览器
   * true 为微信浏览器  false 不为微信
   */
  isWeiXin: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      var bo = true;
      return bo;
    } else {
      var bo = false;
      return bo;
    }
  },


  /**
   * 根据时间 获取年月日
   */
  getdataForTime: function (time) {
    var Tomorrow = new Date(time);
    var Tomorrowyear = Tomorrow.getFullYear();
    var TomorrowMonth = Tomorrow.getMonth() + 1;
    var TomorrowDay = Tomorrow.getDate();
    var TomorrowDate = this.getParTime(TomorrowDay, TomorrowMonth, Tomorrowyear);
    return TomorrowDate;
  },
  /**
   * 设置年月日
   */
  getParTime: function (newDay, newMonth, newYear) {
    newDay = Number(newDay);
    newMonth = Number(newMonth);
    var data = '';
    if (newMonth < 10 && newDay < 10) {
      var data = newYear + '-0' + newMonth + '-0' + newDay;
    } else if (newMonth >= 10 && newDay < 10) {
      var data = newYear + '-' + newMonth + '-0' + newDay;
    } else if (newMonth >= 10 && newDay >= 10) {
      var data = newYear + '-' + newMonth + '-' + newDay;
    } else if (newMonth < 10 && newDay >= 10) {
      var data = newYear + '-0' + newMonth + '-' + newDay;
    }
    return data;
  },
  /**
   * 获取当月的最后一天
   */
  getNewMonthLostDay(newData) {
    // let data = this.getdataForTime(this.getCurrentMonthLast(newData));
    let data = newData.split(' ')[0]; // 测试那边希望是当天的
    return data;
  },
  getCurrentMonthLast(newData) {
    let time = this.timeFitApple(newData);
    var date = new Date(time);
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    return new Date(nextMonthFirstDay - oneDay);
  },
  timeFitApple(time) {
    //时间适配一下苹果的转换
    var desc = time.replace(/-/g, '/');
    return desc;
  },

  /**格式2012-12-01 12:01:11，获取日期年月日时分秒数组 */
  getDateToObj(date) {
    let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
    if (!reg.test(date)) {
      return null;
    }

    let dateTimeArr = date.split(' ');
    let dateArr = dateTimeArr[0].split('-');
    let timeArr = dateTimeArr[1].split(':');
    return {
      year: dateArr[0],
      month: dateArr[1],
      day: dateArr[2],
      hour: timeArr[0],
      minute: timeArr[1],
      second: timeArr[2]
    };
  },


  /**
   * 资费记录参数的整合
   */
  postageParames(tex) {
    if (!tex) {
      return '';
    }
    let obj = {
      '云主机': '云主机业务',
      '云磁盘': '磁盘业务',
      '云IP': 'IP业务',
      '磁盘快照': '快照业务',
      '带宽': '带宽业务,带宽包业务,VPC带宽业务',
      'NAT网关': 'NAT业务',
      'SLB负载均衡': 'slb业务',
      'WEB应用防火墙': 'WAF业务',
      '镜像服务': '镜像业务',
      '购买': 'create',
      '变更': 'adjust',
      '续费': 'renew',
      '销毁': 'destroy'
    }
    return obj[tex];
  },
  /**
   * 站内信息参数整和----类型
   */
  stationnewTypeParames(tex) {
    let obj = {
      '全部类型': '',
      '销毁提醒': 'destroy',
      '到期提醒': 'expire',
      '操作提醒': 'opt',
      '财务消息': 'finance',
      '安全消息': 'security',
      '备案消息': 'record',
      '监控消息': 'warning'
    }
    return obj[tex];
  },
  /**
   * 站内信息参数整和----状态
   */
  stationnewStateParames(tex) {
    let obj = {
      '全部状态': '',
      '未读': '0',
      '已读': '1',
    }
    return obj[tex];
  },

  /**
   * 判断安卓机子
   */
  isAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    let bo = isAndroid ? 'vertical-center' : '';
    return bo;
  },

  /**
   * 下面是用来检验密码的
   */
  regPasswdOne(p1) {
    if (!p1) {
      this.toastMsg('请输入密码');
      return false;
    } else if (p1.length < 8 || p1.length > 32) {
      this.toastMsg('密码长度不能超过32个位，不能少于6位');
      return false;
    } else if (!verification.passWord(p1)) {
      this.toastMsg(' 密码为8-32位字符，至少包含(数字、大写字母、小写字母、特殊字符)中的3种字符。');
      return false;
    }
    var regPass = /^[\S]{5,32}$/i;
    if (!regPass.test(p1)) {
      this.toastMsg('密码不能含有空白字符');
      return false;
    }
    return true;
  },

  comfirm(object) {
    MessageBox({
      title: object.title,
      message: object.message,
      showCancelButton: true,
      closeOnClickModal: false,
      confirmButtonText: object.confirmButtonText ? object.confirmButtonText : '确定',
      cancelButtonText: object.cancelButtonText ? object.cancelButtonText : '取消',
    }).then(action => {
      if (action === 'confirm') {
        object.confirm();
      } else {
        object.cancel();
      }
    })
  },

  /**
   * 防止多次出现弹框tips
   */
  showTips: '',
  toastMsg: function (msg) {
    if (this.showTips) {
      this.showTips.close();
    }
    if (!msg) {
      return;
    }
    this.showTips = Toast(msg);
  },
  showLoading(msg) {
    Indicator.open(msg);
  },

  closeLoading() {
    Indicator.close();
  },

  toastSuccessMsg: function (msg) {
    if (this.showTips) {
      this.showTips.close();
    }
    if (!msg) {
      return;
    }
    this.showTips = Toast({
      message: msg,
      iconClass: 'iconfont icon-selected',
    });
    ;
  },

  /**
   * 获取url路径后面的参数
   */
  getParforUrl: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r && r != null) return unescape(r[2]);
    return null;
  },
  /**
   * 重置url
   */
  resetUrl() {
    let state = { title: '', url: location.href.split('?')[0] };
    history.replaceState(state, '', state.url);
  },
  /**
   * 获取到推广者的ID并且储存在cookies里面
   */
  promotersIDCookies: function () {
    let promotersID = this.getParforUrl('salesID');
    if (promotersID) {
      this.setCookies('promotersID', promotersID, 30);
    }
  },

  /**
   * 设置 cookies
   * common.set('test','甘科',1);
   */
  setCookies: function (key, val, time) {//设置cookie方法
    // var date=new Date(); //获取当前时间
    // var expiresDays=time;  //将date设置为n天以后的时间
    // date.setTime(date.getTime()+expiresDays*24*3600*1000); //格式化为cookie识别的时间
    // document.cookie=key + "=" + escape(val)  +";expires="+date.toUTCString()+";path=/;"+";domain="+window.location.host;  //设置cookie

    $.cookie(key, val, {expires: time, path: '/'});
  },
  /**
   * 获取cookies的值
   * let name = common.get('test');
   */
  getCookies: function (key) {
    // var desc = '';
    // var reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    // var tips = document.cookie.match(reg);
    // if(tips){
    //     desc = unescape(tips[2]);
    // }
    // return desc;
    let desc = '';
    desc = $.cookie(key);
    return desc;
  },
  /**
   * 删除cookies的值
   * common.delete('test');
   */
  delete: function (key) { //删除cookie方法
    // var date = new Date(); //获取当前时间
    // date.setTime(date.getTime()-1); //将date设置为过去的时间
    // var val = this.getCookies(key)
    // document.cookie = key + "="+val+"; expires =" +date.toGMTString()+";path=/;"+";domain="+window.location.host;//设置cookie

    $.removeCookie(key, {path: '/'});
    $.removeCookie(key, {path: '/', domain: window.location.host});
  },

  /**
   * 会话储存
   */
  setSessionStorage: function (key, value) {
    sessionStorage.setItem(key, value);
  },
  /**
   * 会话获取对应数据
   */
  getSessionStorage: function (key) {
    var desc = sessionStorage.getItem(key);
    return desc;
  },
  /**
   * 会话删除对应数据
   */
  deleteSessionStorage: function (key) {
    sessionStorage.removeItem(key);
  },

  /**
   * 会话删除对应数据
   */
  judgeBaiduStatistics: function () {
    let href = window.location.href;
    let host = window.location.host;
    href = href.split('?')[0];
    if (host == 'm.eflycloud.com') {
      if (href === 'https://m.eflycloud.com/' || href === 'https://m.eflycloud.com') {
        return true;
      } else {
        if (href.indexOf('other') !== -1 || href.indexOf('solve') !== -1 || href.indexOf('product') !== -1 || href.indexOf('data') !== -1 || href.indexOf('active') !== -1) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  },

  /**
  * 账号实名审核状态，优先显示企业认证状态
  * @param userInfo {Object} 用户信息
  * @param person {Number} 个人实名认证状态 -- 0：未认证|-1：待审核|-2：认证失败|-3：审核中|1：认证成功
  * @param company {Number} 企业实名认证状态 -- 0：未认证|-1：认证失败|-2：审核中|1：认证成功
  * @param type {String} 返回实名类型 -- text:文字|color:颜色|icon:图标
  * @reutrn value {String} 账号实名认证状态
  * */
  getRealNameStatus(userInfo, type = 'text') {
    var company = userInfo.companyVerifyStatus, person = userInfo.realNameVerify;
    var status = '', color = '', icon = '', url = '';
    switch (company) {
      case 0: {
        switch (person) {
          case 0: {
            status = '未实名认证';
            break;
          }
          case -1: {
            status = '个人认证待审核';
            break;
          }
          case -2: {
            status = '个人认证失败';
            break;
          }
          case -3: {
            status = '个人认证审核中';
            break;
          }
          case 1: {
            status = '个人认证成功';
            break;
          }
        }
        break;
      }
      case -1: {
        status = '企业认证失败'
        break;
      }
      case -2: {
        status = '企业认证审核中'
        break;
      }
      case -3: {
        status = '企业认证待审核'
        break;
      }
      case 1: {
        status = '企业认证成功'
        break;
      }
    }
    switch (status) {
      case '未实名认证': {
        color = 'text-muted';
        icon = 'rj-icon-person';
        url = "real-name-choose";
        break;
      }
      case '个人认证待审核': {
        color = 'text-warming';
        icon = 'rj-icon-person';
        url = "real-name-tips";
        break;
      }
      case '个人认证失败': {
        color = 'text-danger';
        icon = 'rj-icon-person';
        url = "real-name-write"
        break;
      }
      case '个人认证审核中': {
        color = 'text-warming';
        icon = 'rj-icon-person';
        url = "real-name-tips";
        break;
      }
      case '个人认证成功': {
        color = 'text-muted';
        icon = 'text-success';
        url = "real-name-success"
        break;
      }
      case '企业认证失败': {
        color = 'text-danger';
        icon = 'rj-icon-company-cirle';
        url = "real-name-write"
        break;
      }
      case '企业认证审核中': {
        color = 'text-warming';
        icon = 'rj-icon-company-cirle';
        url = "real-name-tips"
        break;
      }
      case '企业认证待审核': {
        color = 'text-warming';
        icon = 'rj-icon-company-cirle';
        url = "real-name-tips"
        break;
      }
      case '企业认证成功': {
        color = 'text-success';
        icon = 'rj-icon-company-cirle';
        url = "real-name-success"
        break;
      }
    }
    if (type === 'text') {
      return status;
    } else if (type === 'color') {
      return color;
    } else if (type === 'icon') {
      return icon;
    } else if (type === 'url') {
      return url;
    }
  }
}
export {
  common
}



// WEBPACK FOOTER //
// ./src/common/js/common.js